import { get } from 'es-toolkit/compat'
import { empty } from '/@/shared/utils'
import { defaultFrequencyDivider } from '/@/shared/config'
export default {
  props: {
    model: {
      type: Object,
      default: null,
    },
  },
  computed: {
    posX() {
      return get(this.model, 'x.value', 0)
    },
    posY() {
      return get(this.model, 'y.value', 0)
    },
    zIndex() {
      return get(this.model, 'z.value', 0)
    },
    filter() {
      return get(this.model, 'filter', null)
    },
    filterUnit() {
      return get(this.model, 'filter.settings.unit', null)
    },
    min() {
      return get(this.model, 'min.value', 0)
    },
    max() {
      return get(this.model, 'max.value', 0)
    },
    step() {
      return get(this.model, 'step.value', 0)
    },
    width() {
      return get(this.model, 'width.value', 100)
    },
    height() {
      return get(this.model, 'height.value', 100)
    },
    label() {
      return get(this.model, 'label.value', '')
    },
    color() {
      return get(this.model, 'color.value', '')
    },
    unit() {
      return get(this.model, 'unit.value', 0)
    },
    decimals() {
      return get(this.model, 'decimals.value', 0)
    },
    fontSize() {
      return this.model.fontSize.value
    },
    fontWeight() {
      return get(this.model, 'fontWeight.value', 400)
    },
    lineHeight() {
      return get(this.model, 'lineHeight.value', 12)
    },
    align() {
      return get(this.model, 'align.value', 'right')
    },
    toHex() {
      return get(this.model, 'toHex.value', false)
    },
    frequencyDivider() {
      return get(this.model, 'frequencyDivider.value', defaultFrequencyDivider)
    },
    pathPrefix() {
      return get(this.model, 'path.settings.prefix', '')
    },
    pathSlot() {
      return get(this.model, 'path.settings.slot', null)
    },
    pathSettings() {
      return get(this.model, 'path.settings', null)
    },
    pathExpression() {
      return get(this.model, 'path.settings.expression', null)
    },
    path() {
      return this.pathPrefix + get(this.model, 'path.value', null)
    },
    visibilityPrefix() {
      return get(this.model, 'visibility.settings.prefix', '')
    },
    visibilitySlot() {
      return get(this.model, 'visibility.settings.slot', null)
    },
    visibilityExpression() {
      return get(this.model, 'visibility.settings.expression', null)
    },
    visibility() {
      return this.visibilityPrefix + get(this.model, 'visibility.value', null)
    },
    opacity() {
      return this.isDragging ? 1 : 0
    },
    hasFilter() {
      return !empty(this.filter)
    },
    hasFilterUnit() {
      return !empty(this.filterUnit)
    },
    hasUnit() {
      return !empty(this.unit)
    },
    isBackgroundVisible() {
      return this.artboards.models.active.some((m) => m.id === this.model.id)
    },
    isScaleVisible() {
      return this.artboards.models.active.map((m) => m.id).includes(this.model.id)
    },
    backgroundStyleObject() {
      const opacity = this.isBackgroundVisible ? 1 : 0

      return {
        opacity: opacity,
      }
    },
    isAdmin() {
      return this.$route.fullPath.includes('admin')
    },
  },
}
